export class InsuranceTypes {
    static liability = 'Haftpflicht';
    static fullyComprehensive = 'Vollkasko';
    static fullyComprehensiveStopLoss = 'Vollkasko Stop-Loss';
    static partialCoverage = 'Teilkasko';
    static lossRepurchase = 'Schadenrückkauf';
}
